import { render, staticRenderFns } from "./ProfileEmployeeStatus.vue?vue&type=template&id=6b3decd9&scoped=true"
import script from "./ProfileEmployeeStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileEmployeeStatus.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProfileEmployeeStatus.vue?vue&type=style&index=0&id=6b3decd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3decd9",
  null
  
)

export default component.exports